import type { GetKeyInitiativesParams } from '../model/types'

export const getKeyInitiativesTagId = ({
  partnerId,
  fYear,
  programType,
}: GetKeyInitiativesParams): string => `${partnerId}::${fYear}::${programType ?? ''}`
